import { ArrowUpward, ArrowDownward, Close, Add, Upload, Height } from "@mui/icons-material"
import { Stack, Typography, Button, IconButton, Alert, Divider } from "@mui/material"
import FormSelect from "../form/FormSelect"
import FormSwitch from "../form/FormSwitch"
import FormText from "../form/FormText"
import { Fragment, useEffect, useState } from "react"
import axios from "axios"
import { HomePageItem } from "./news.interface"
import { IFormEvent } from "../form/Form.interface"
import Util, { moveItem } from "../services/util"
import SelectNews from "./SelectNews"
import FormImage from "../form/FormImage"
import SelectImgs from "./SelectImgs"
import FormDate from "../form/FormDate"
import { APIHOST } from "../services/api.service"

export default function HomePageForm({ news, save }: { news: any, save: (news: any) => void }) {

  const [form, setForm] = useState<HomePageItem>(news)
  const [selectNews, setSelectNews] = useState<{ i: number, ii: number }>()
  const [selectImgs, setSelectImgs] = useState<{ i: number, ii: number, id: string[] }>()
  const [channelOption, setChannelOption] = useState<any>([])
  const [tagOption, setTagOption] = useState<any>([])
  const [dirty, setDirty] = useState<boolean>(false)

  useEffect(() => {
    axios.post('cms/channelsIndex', {}).then(({ data }) => {
      setChannelOption(data)
    })
    axios.post('cms/tagsIndex', { channel: true }).then(({ data }) => {
      setTagOption(data)
    })
  }, [])

  useEffect(() => {
    setForm({ ...news, where: { tags: '', channel: '', keyword: '', length: 2, ...news.where } })
    setDirty(false)
  }, [news])

  function handleFormChange(e: IFormEvent): void {
    setDirty(true)
    setForm(Util.formChange(e, form))
  }

  return <Stack spacing={1} sx={{ zoom: .8 }}>
    <Stack direction={"row"}>
      <Typography variant="h6" flexGrow={1}>模块设置</Typography>
      <Button disabled={!dirty} variant="contained" onClick={() => {
        save(form)
      }}>保存</Button>
    </Stack>
    <Stack direction={"row"} spacing={2}>
      <FormSwitch name={"show"} value={form.show} label={"显示"} onChange={handleFormChange}></FormSwitch>
      <FormSwitch name={"auto"} value={form.auto} label={"自动更新"} onChange={handleFormChange}></FormSwitch>
      <FormText type="number" label="顺序" name="sort" value={form.sort} onChange={handleFormChange}></FormText>
    </Stack>
    <Divider />
    {form.auto ? <Stack spacing={1}>
      <Typography variant="caption">自动更新条件</Typography>
      <FormSelect label="频道" name="where.channel" value={form.where?.channel} onChange={handleFormChange}
        options={[{ title: '不限', value: '' }, ...channelOption]} />
      <FormText label="包含标签" value={form.where?.tags} name="where.tags" onChange={handleFormChange}></FormText>
      <FormText label="标题关键字" value={form.where?.keyword} name="where.keyword" onChange={handleFormChange}></FormText>
      <FormText type="number" label="条数" value={form.where?.length} name="where.length" onChange={handleFormChange}></FormText>
    </Stack> : <Stack spacing={2} >
      {form.item.map((item, index) => <Stack key={index}>
        <Stack direction={"row"}>
          <Typography variant="h6" color="primary">{`组合 ${index + 1} : `}</Typography>
          <Stack flexGrow={1}  >
          </Stack>
          <Stack direction={"row"} sx={{ backgroundColor: 'rgba(125,125,125,0.3)', borderRadius: 30 }} >
            <IconButton size="small" disabled={index === 0} onClick={() => {
              const element = form.item.splice(index, 1)[0]
              form.item.splice(index - 1, 0, element)
              setDirty(true)
              setForm({ ...form })
            }}><ArrowUpward /></IconButton>
            <IconButton size="small" disabled={index + 1 === form.item.length} onClick={() => {
              const element = form.item.splice(index, 1)[0]
              form.item.splice(index + 1, 0, element)
              setDirty(true)
              setForm({ ...form })
            }}><ArrowDownward /></IconButton>
            <IconButton size="small" onClick={() => {
              form.item.splice(index, 1)
              setDirty(true)
              setForm({ ...form })
            }}><Close /></IconButton>
          </Stack>


        </Stack>
        <Stack direction={"row"} spacing={2}>
          <FormSelect name={`item.${index}.imgMode`} value={item.imgMode} onChange={handleFormChange} label={"模式"}
            options={['小图', '大图', '并列', '划动'].map((x, xi) => ({ title: x, value: xi }))}
          />
          <FormSwitch name={`item.${index}.bold`} value={item.bold} label={"粗体"} onChange={handleFormChange} />
          <FormSwitch name={`item.${index}.red`} value={item.red} label={"红"} onChange={handleFormChange} />
          <FormSelect name={`item.${index}.imgAspect`} value={item.imgAspect} onChange={handleFormChange} label={"图片比例"}
            options={[{ title: '横图', value: 0.6 }, { title: '竖图', value: 2.2 }, { title: '自动', value: 0 }]}
          />
          {/* <FormDate disabled={true} name={`item.${index}.pubDate`} value={item.pubDate} label={"发布时间"} onChange={handleFormChange} /> */}

        </Stack>
        <Divider sx={{ m: 2 }} />
        <Stack sx={{ ml: 2 }} direction={"row"} alignItems={"center"} spacing={2}>
          <Stack flexGrow={1} spacing={5}>
            {item.title.map((tit, tindex) => <Stack
              spacing={2} key={tindex} >
              <Stack direction={"row"} >
                <Typography variant="caption" color="primary" flexGrow={1}>{`新闻${tindex + 1} : `}</Typography>
                <IconButton disabled={tindex === 0} size="small" onClick={() => {
                  item.title = moveItem(item.title, tindex, -1)
                  item.links = moveItem(item.links, tindex, -1)
                  item.imgs = moveItem(item.imgs, tindex, -1)
                  setDirty(true)
                  setForm({ ...form })
                }}><ArrowUpward /></IconButton>
                <IconButton disabled={item.title.length - 1 === tindex} size="small" sx={{ mr: 4 }} onClick={() => {
                  item.title = moveItem(item.title, tindex, 1)
                  item.links = moveItem(item.links, tindex, 1)
                  item.imgs = moveItem(item.imgs, tindex, 1)
                  setDirty(true)
                  setForm({ ...form })
                }}><ArrowDownward /></IconButton>
              </Stack>
              {!(item.imgMode === 0 && tindex > 0) && <Fragment>
                <FormText helperText="置空时不显示" sx={{ flexGrow: 1 }} label={`标题`} name={`item.${index}.title.${tindex}`} value={tit} onChange={handleFormChange} />
              </Fragment>}
              <Stack direction={"row"} spacing={2}>
                <Typography variant="caption">链接</Typography>
                <FormText disabled={!!(item.links[tindex].channel || item.links[tindex].tag)} label="新闻ID" name={`item.${index}.links.${tindex}.id`} value={item.links[tindex].id} onChange={handleFormChange} />
                <Typography variant="caption">或</Typography>
                <FormSelect label="频道" name={`item.${index}.links.${tindex}.channel`}
                  value={item.links[tindex].channel} onChange={handleFormChange}
                  options={[{ title: '无', value: '' }, ...channelOption]} />
                <FormSelect label="标签" name={`item.${index}.links.${tindex}.tag`}
                  value={item.links[tindex].tag} onChange={handleFormChange}
                  options={[{ title: '无', value: '' }, ...tagOption.filter((t: any) => item.links[tindex].channel ? t.channel === item.links[tindex].channel : true)]} />
              </Stack>
              <Stack direction={"row"} alignItems={"center"} sx={{ minHeight: 60 }} spacing={2}>
                <Stack sx={{ width: 100, height: item.imgAspect ? 100 * item.imgAspect : 'auto', border: '1px solid #9e9e9e', overflow: 'hidden' }}>
                  <FormImage sx={{ width: 100, height: item.imgAspect ? 100 * item.imgAspect : 'auto', }}
                    label="图"
                    name={`item.${index}.imgs.${tindex}`}
                    value={item.imgs[tindex]} onChange={(e) => {
                      e.target.value = APIHOST + '/upload/' + e.target.value
                      handleFormChange(e)
                    }} />
                </Stack>
                <Button onClick={() => {
                  console.log(item)
                  handleFormChange({ target: { name: `item.${index}.imgs.${tindex}`, value: '' } })
                }}>删除图片</Button>
                <Button onClick={() => {
                  item.title.splice(tindex, 1)
                  item.imgs.splice(tindex, 1)
                  item.links.splice(tindex, 1)
                  setDirty(true)
                  setForm({ ...form })
                }}>删除新闻</Button>
              </Stack>
            </Stack>)}
            <Stack flexDirection={"row"}>
              <Button startIcon={<Add />} onClick={() => {
                setSelectNews({ i: index, ii: -1 })
              }}>选取新闻</Button>
              <Button startIcon={<Upload />} onClick={() => {
                setSelectImgs({ i: index, ii: -1, id: item.links.map(l => l.id) })
              }}>添加题图</Button>
            </Stack>
          </Stack>

        </Stack>
        <Divider />
      </Stack>)}
      {!form.item.length && <Alert color="info">请添加</Alert>}

      <Stack direction={"row"}>
        <Button startIcon={<Add />} variant="outlined" onClick={() => {
          form.item.unshift({
            bold: false,
            red: false,
            imgMode: 0,
            imgAspect: .6,
            pubDate: Date.now(),
            imgs: [],
            title: [],
            links: []
          })
          setForm({ ...form })
        }}>添加组合 </Button>
      </Stack>
    </Stack>}
    {selectNews && <SelectNews onClose={(news) => {
      if (news) {
        const { title, _id: id, newimg } = news
        if (selectNews.ii > -1) {
          form.item[selectNews.i].title[selectNews.ii] = title
          form.item[selectNews.i].links[selectNews.ii] = form.item[selectNews.i].links[selectNews.ii] || {}
          form.item[selectNews.i].links[selectNews.ii].id = id
          form.item[selectNews.i].imgs[selectNews.ii] = newimg[0]
        } else {
          form.item[selectNews.i].title.unshift(title)
          form.item[selectNews.i].links.unshift({ id, channel: '', tag: '' })
          form.item[selectNews.i].imgs.unshift(newimg[0])
        }
        setDirty(true)
        setForm(form)
      }
      setSelectNews(undefined);
    }} />}

    {selectImgs && <SelectImgs id={selectImgs.id} onClose={(url?: string) => {
      if (url) {
        if (selectImgs.ii > -1) {
          console.log(form.item[selectImgs.i].title[selectImgs.ii - 1])
          form.item[selectImgs.i].title[selectImgs.ii] = form.item[selectImgs.i].title[selectImgs.ii - 1] || ''
          form.item[selectImgs.i].links[selectImgs.ii] = form.item[selectImgs.i].links[selectImgs.ii] || {}
          form.item[selectImgs.i].links[selectImgs.ii].id = form.item[selectImgs.i].links[selectImgs.ii - 1].id || ''
          form.item[selectImgs.i].imgs[selectImgs.ii] = url
        } else {
          const thisitem = form.item[selectImgs.i]
          const { id, tag, channel } = thisitem.links[thisitem.links.length - 1] || { id: '', channel: '', tag: '' }
          form.item[selectImgs.i].title.push(thisitem.title[thisitem.title.length - 1] || '')
          form.item[selectImgs.i].links.push({ id, channel, tag })
          form.item[selectImgs.i].imgs.push(url)
        }
        setDirty(true)
        setForm(form)
      }
      setSelectImgs(undefined)
    }}></SelectImgs>}
  </Stack>
}